<div class="background-mask-group rounded-4">
  <div class="d-flex flex-column rounded-4 p-3 flex-lg-row justify-content-center">
    <div class="col-lg-6 content-box text-lg-start text-white text-left">
      <div>
        <div class="font-page-heading text-uppercase font-size-30">{{ 'offer.page.title' | translate }}</div>
        <div class="font-default">
          {{ 'offer.page.desc' | translate }}
        </div>
      </div>
      <div class="buttons bg-white btn-width text-black" id="buttonsContainer">
        <b>{{ 'offer.page.view.my.offers' | translate }}</b>
      </div>
    </div>
    <div class="col-lg-6 col-12"></div>
  </div>
</div>
